var map = {
	"./001_roundandround.gif": "fada",
	"./002_conforza.gif": "e02a",
	"./003_thelevitation.gif": "45af",
	"./004_telepathy.gif": "0672",
	"./005_retrofocus.png": "a370",
	"./006_defaultroute.png": "8f16",
	"./anal.jpg": "94b2",
	"./undefined.gif": "1212"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f976";